import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
} from '@angular/core';

import { keyCode } from '@ridango/core/lib/enums/keyboard.enum';
import { ListService } from '@ridango/core/lib/services';

let identifier = 0;

@Component({
    selector: 'ridango-account-actions-selector',
    templateUrl: './account-actions-selector.component.html',
    styleUrls: ['./account-actions-selector.component.scss'],
})
export class AccountActionsSelectorComponent {
    @Input() isOpened = false;
    @Input() disabled = false;
    @Input() actions = [];
    @Input() locale = 'en';

    @Output() onDropdownStatusChange = new EventEmitter<boolean>();
    @Output() onActionClicked = new EventEmitter<string>();

    @ViewChild('menuButton') menuButton: ElementRef;
    @ViewChildren('menuItem') menuItems: QueryList<ElementRef>;

    selectedIndex = 0;

    menuButtonId = `account-actions-selector-button-${++identifier}`;
    menuId = `account-actions-selector-menu-${identifier}`;

    constructor(private eRef: ElementRef, private listService: ListService) {}

    @HostListener('document:click', ['$event']) onClickOut(event) {
        if (event.target.className.indexOf('card-actions-selector') >= 0) {
            this.onDropdownStatusChange.emit(true);
        } else {
            this.onDropdownStatusChange.emit(false);
            this.selectedIndex = 0;
        }
    }

    actionClicked(action: string) {
        this.onActionClicked.emit(action);
    }

    openClicked(event) {
        event.stopPropagation();
        event.preventDefault();

        if (!this.disabled && !this.isOpened) {
            this.onDropdownStatusChange.emit(true);
            setTimeout(() => this.menuItems.toArray()[this.selectedIndex].nativeElement.focus());
        } else {
            this.onDropdownStatusChange.emit(false);
        }
    }

    closeMenu(): void {
        this.onDropdownStatusChange.emit(false);
        this.selectedIndex = 0;
        this.menuButton.nativeElement.focus();
    }

    onMenuItemKeyDown(event: KeyboardEvent, action: string) {
        switch (event.keyCode) {
            case keyCode.ENTER:
            case keyCode.SPACE:
                event.preventDefault();
                this.actionClicked(action);
                break;
            case keyCode.ESCAPE:
            case keyCode.TAB:
                this.closeMenu();
                break;
            case keyCode.ARROW_DOWN:
                event.preventDefault();
                this.selectNextItem(1);
                break;
            case keyCode.ARROW_UP:
                event.preventDefault();
                this.selectNextItem(-1);
                break;
        }
    }

    private selectNextItem(direction: number): void {
        this.selectedIndex = this.listService.getNextCyclicIndex(this.selectedIndex, direction, this.actions.length);
        setTimeout(() => this.menuItems.toArray()[this.selectedIndex].nativeElement.focus());
    }
}
